'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectableLabel = function SelectableLabel(props) {
  var action = props.action,
      appearance = props.appearance,
      label = props.label,
      group = props.group,
      selected = props.selected,
      iconUnselected = props.iconUnselected,
      iconSelected = props.iconSelected;

  var selectedClass = selected ? 'selected' : '';
  var icon = selected && iconSelected || !selected && iconUnselected;

  return _react2.default.createElement(
    'button',
    { type: 'button', className: 'SelectableLabel ' + appearance + ' ' + selectedClass, onClick: action, onKeyPress: (0, _utils.handleKeyPress)(action) },
    group && _react2.default.createElement(
      'span',
      { className: 'group' },
      group
    ),
    label,
    icon && _react2.default.createElement(_Icon2.default, { name: icon })
  );
};

SelectableLabel.propTypes = {
  /** Action triggered when the label is clicked. */
  action: _propTypes2.default.func,
  /** Which style to apply. */
  appearance: _propTypes2.default.oneOf(['plain', 'filter', 'tag']),
  /** Label for the selectable item. */
  label: _propTypes2.default.string.isRequired,
  /** Group (displayed to the left of the label) for the selectable item. */
  group: _propTypes2.default.string,
  /** Selected status. A boolean. */
  selected: _propTypes2.default.bool,
  /** The name of the icon to append to the label when it is selected. */
  iconSelected: _propTypes2.default.string,
  /** The name of the icon to append to the label when it is not selected. */
  iconUnselected: _propTypes2.default.string
};

SelectableLabel.defaultProps = {
  action: null,
  appearance: 'filter',
  group: null,
  iconSelected: 'x',
  iconUnselected: null,
  selected: false
};

exports.default = SelectableLabel;
SelectableLabel.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'SelectableLabel',
  'props': {
    'action': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Action triggered when the label is clicked.'
    },
    'appearance': {
      'defaultValue': {
        'value': '\'filter\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'plain\'',
          'computed': false
        }, {
          'value': '\'filter\'',
          'computed': false
        }, {
          'value': '\'tag\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Which style to apply.'
    },
    'group': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Group (displayed to the left of the label) for the selectable item.'
    },
    'iconSelected': {
      'defaultValue': {
        'value': '\'x\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to append to the label when it is selected.'
    },
    'iconUnselected': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to append to the label when it is not selected.'
    },
    'selected': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Selected status. A boolean.'
    },
    'label': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Label for the selectable item.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SelectableLabel.js
// module id = 273
// module chunks = 0